import {
  CircularProgress,
  Divider,
  Grid2,
  RadioButtonIcon,
  SuccessFilledIcon,
  Typography,
  styled,
} from "components";
import { useFormContext } from "react-hook-form";

interface Props {
  activeStep: number;
  loading?: boolean;
  formik?: {
    values: {
      fileUploadType?: string;
    };
  };
  format?: string;
  stepColors?: {
    completed?: string;
    pending?: string;
  };
  iconSize?: number;
  showPortfolioMappingStep?: boolean;
}

const CustomSection = styled("section")({
  display: "flex",
  alignItems: "center",
  gap: 8,
  width: "100%",
});

const UploadManagerStepperModal = ({
  activeStep,
  loading = false,
  formik,
  format = "",
  stepColors = {},
  iconSize = 15,
  showPortfolioMappingStep = true,
}: Props) => {
  const currentActiveStep = activeStep - 1;

  const form = useFormContext();

  const { completed = "var(--success-700)", pending = "var(--neutral-500)" } =
    stepColors;

  const steps = [
    {
      label: "File Upload",
      subLabel: "File uploaded successfully.",
      show: true,
    },
    {
      label: "Portfolio Mapping",
      subLabel: "Mappings successfully.",
      show: showPortfolioMappingStep,
    },
    {
      label: "Company Mapping",
      subLabel: "Company Mapping successfully.",
      show:
        (formik?.values?.fileUploadType?.toLowerCase() !== "cash" &&
          format !== "LEDGER") ||
        (form.getValues("fileUploadType")?.toLowerCase() !== "cash" &&
          format !== "LEDGER"),
    },
    { label: "Review File", subLabel: "Review successfully.", show: true },
    {
      label: "Transaction Upload",
      subLabel: "Transactions uploaded successfully.",
      show: true,
    },
  ];

  const renderIcon = (index: number) => {
    if (currentActiveStep < index)
      return (
        <RadioButtonIcon height={iconSize} width={iconSize} color={pending} />
      );
    if (loading && currentActiveStep === index)
      return <CircularProgress size={iconSize} />;
    if (currentActiveStep > index)
      return (
        <SuccessFilledIcon
          height={iconSize}
          width={iconSize}
          color={completed}
        />
      );
    return null;
  };

  return (
    <Grid2 container justifyContent="center" alignItems="center">
      {steps.map(
        (step, index) =>
          step.show && (
            <Grid2
              key={step.label}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
              }}
            >
              <CustomSection>
                {renderIcon(index)}
                <Typography
                  variant="body2"
                  fontWeight={700}
                  color={"var(--neutral-500)"}
                  sx={{ whiteSpace: "nowrap" }}
                >
                  {step.label}
                </Typography>
                {index < steps.length - 1 && (
                  <Divider sx={{ width: 30, marginRight: 1 }} />
                )}
              </CustomSection>
            </Grid2>
          ),
      )}
    </Grid2>
  );
};

export default UploadManagerStepperModal;
